import { render, staticRenderFns } from "./StandaloneForgeViewer.vue?vue&type=template&id=98cd8672&scoped=true"
import script from "./StandaloneForgeViewer.vue?vue&type=script&lang=js"
export * from "./StandaloneForgeViewer.vue?vue&type=script&lang=js"
import style0 from "./StandaloneForgeViewer.vue?vue&type=style&index=0&id=98cd8672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cd8672",
  null
  
)

export default component.exports